export default __webpack_public_path__ + "static/media/queue_urgent.7749e911.svg";